"use client"

import React from 'react';
import styles from "./PostsList.module.scss";
import usePostsData from "@/utils/hooks/usePostsData";
import useUserInfo from "@/utils/hooks/useUserInfo";
import {Link, useRouter} from "@/i18n/routing";
import {useTranslations} from "use-intl";
import {BiSolidMessageRoundedEdit} from "react-icons/bi";
import {Button, Divider, IconButton, Tooltip} from "@mui/material";
import Image from "next/image";


export default function PostsList() {
  const t = useTranslations("Main")
  const userInfo = useUserInfo()
  const data = usePostsData()
  const router = useRouter()
  return <div className={styles.container}>
    <h3 className={styles.pageTitle}>{t("posts_list")}</h3>

    <Button
      variant={"contained"}
      color={'secondary'}
      className={styles.submit}
      onClick={() => {
        router.push("create-share")
      }}
    >
      {t("create_post")}
    </Button>
    <Divider sx={{my: 3}}/>
    <div className={styles.postsWrapper}>
      {data && data.items?.map((item, key) => {
        return <div className={styles.postsItemWrapper} key={key}>
          <h5>{item.title}</h5>
          <div dangerouslySetInnerHTML={{__html: item.content}}/>
          <div className={styles.author}>{item.author.name} {item.author.surname}</div>
          <div className={styles.postImagesWrapper}>
            {item.images.map((itm, key) => {
              return <Image unoptimized key={key} width={100} height={100} src={itm.url} alt={itm.name}/>
            })}
          </div>
          {item.author?.id === userInfo?.id && <Link href={`/share/edit/${item.id}`}>
            <Tooltip title={t("edit")}>
              <IconButton aria-label={t("edit")} color={"secondary"} size="small">
                <BiSolidMessageRoundedEdit size={25}/>
              </IconButton>
            </Tooltip>
          </Link>}
        </div>
      })}
    </div>
    <Button
      variant={"contained"}
      color={'secondary'}
      className={styles.submit}
      onClick={() => {
        router.push("create-share")
      }}
    >
      {t("create_post")}
    </Button>

  </div>
}
